/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


// (function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  // document.addEventListener('theme:variant:change', function(event) {
  //   // You might use something like this to write a pre-order feature or a
  //   // custom swatch feature.
  //   var variant = event.detail.variant;
  //   var container = event.target;
  //   if (variant) {
  //     console.log('Container ———————— ↓');
  //     console.log(container);
  //     console.log('Variant —————————— ↓');
  //     console.log(variant);
  //     // ... update some element on the page
  //   }
  // });

  // document.addEventListener('theme:cart:change', function(event) {
  //   var cart = event.detail.cart;
  //   if (cart) {
  //     console.log('Cart ———————————— ↓');
  //     console.log(cart);
  //     // ... update an app or a custom shipping caluclator
  //   }
  // });
  // Fired when page loads to update header values
  // document.addEventListener('theme:cart:init', (e) => {
  //   console.log('theme:cart:init');
  //   console.log(e);
  // });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  // document.addEventListener('theme:scroll', e => { console.log(e); });
  // document.addEventListener('theme:scroll:up', e => { console.log(e); });
  // document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  // document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
// })();


function setCookie(name,value,days) {
  var expires = "";
  if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}
function eraseCookie(name) {   
  document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

// Size chart
document.addEventListener("DOMContentLoaded", function(event){

  // console.log('test custom script');

  // Tabs init
  // var selectedSizeChart = document.querySelector('.product-size-tab-button.selected');
  document.querySelectorAll('.product-size-tab-button.selected').forEach(selectedSizeChart => {
    // if (!selectedSizeChart) {
    //   selectedSizeChart = document.querySelector('.product-size-tab-button');
    //   selectedSizeChart.classList.add('selected');
    // }
    if (selectedSizeChart) {
      selectedSizeChart.parentElement.parentElement.querySelector(`.product-size-tab-content[data-index="${selectedSizeChart.getAttribute('data-index')}"]`).style.display = '';
    }
  })

  // Tabs clicked
  var sizeTabButtons = document.querySelectorAll('.product-size-tab-button');
  if (sizeTabButtons.length > 0){
    sizeChartModalButton = document.querySelector('button[aria-controls="modal-size-chart"]');
    if (sizeChartModalButton){
      sizeChartModalButton.style.display = '';
    }
    sizeTabButtons.forEach(myButton => {
      myButton.onclick = function(event){
        myButton.parentElement.parentElement.querySelectorAll('.product-size-tab-button').forEach(button => {
          button.classList.remove('selected');
        });
        myButton.parentElement.parentElement.querySelectorAll('.product-size-tab-content').forEach(content => {
          content.style.display = 'none';
        });
        myButton.classList.add('selected');
        myButton.parentElement.parentElement.querySelector(`.product-size-tab-content[data-index="${myButton.getAttribute('data-index')}"]`).style.display = '';
        // Find similar tab title
        document.querySelectorAll(`.product-size-tab-button[data-title="${myButton.getAttribute("data-title")}"]`).forEach(similarButton => {
          similarButton.parentElement.parentElement.querySelectorAll('.product-size-tab-button').forEach(button => {
            button.classList.remove('selected');
          });
          similarButton.parentElement.parentElement.querySelectorAll('.product-size-tab-content').forEach(content => {
            content.style.display = 'none';
          });
          similarButton.classList.add('selected');
          similarButton.parentElement.parentElement.querySelector(`.product-size-tab-content[data-index="${similarButton.getAttribute('data-index')}"]`).style.display = '';
        })
      }
    });
  }

  // measurements button clicked
  document.querySelectorAll('button.measurements-tab').forEach(myButton => {

    var sizeTab = myButton.parentElement.parentElement;
    var inchesCols = sizeTab.getAttribute('data-inches-cols').split(',').map(s => parseInt(s));
    var cmCols = sizeTab.getAttribute('data-cm-cols').split(',').map(s => parseInt(s));

    myButton.onclick = function(event){

      var measurement = myButton.getAttribute('data-measument');
      setCookie('preferred_measurement', measurement, 999);

      document.querySelectorAll('button.measurements-tab').forEach(allButtons => {
        if (allButtons.getAttribute('data-measument') == measurement){
          allButtons.classList.add('selected');
        } else {
          allButtons.classList.remove('selected');
        }
      });

      var displaycols = cmCols;
      var hideCols = inchesCols;
      if (measurement == 'ins'){
        displaycols = inchesCols;
        hideCols = cmCols;
      }

      document.querySelectorAll('.product-size-tab-content[data-toggle-measurements="true"]').forEach(tab => {
        tab.querySelectorAll('tbody tr').forEach(row => {
          row.querySelectorAll('td').forEach((col, colIndex) => {
            if (displaycols.indexOf(colIndex+1) != -1){
              col.style.display = '';
            } else if (hideCols.indexOf(colIndex+1) != -1){
              col.style.display = 'none';
            }
          })
        });
      });
    }

  });

  var measurement = getCookie('preferred_measurement');
  if (!measurement){
    measurement = 'ins';
  }
  var firstMeasurementButton = document.querySelector(`button.measurements-tab[data-measument="${measurement}"]`);
  if (firstMeasurementButton){
    firstMeasurementButton.click();
  }

  // Product details dropdown
  var detailsDropdowns = document.querySelectorAll('a[href="#ProductDropdown"]');
  detailsDropdowns.forEach(detailsDropdown => {
    if (detailsDropdown) {
      detailsDropdown.onclick = function(event) {
        event.preventDefault();
        // detailsDropdown.classList.toggle('open');
        var container = detailsDropdown.nextElementSibling;

        if (!detailsDropdown.classList.contains('open')) {
      
          detailsDropdown.classList.add('open');
          container.style.height = 'auto';
    
          var height = container.clientHeight + 'px';
          var transitionDuration = container.clientHeight * 0.0003;
          if (transitionDuration < 0.3){
            transitionDuration = 0.3;
          }
    
          container.style.height = '0px';
    
          setTimeout(function () {
            container.style.transitionDuration = transitionDuration;
            container.style.height = height;
          }, 0);
          
        } else {
          
          container.style.height = '0px';
    
          container.addEventListener('transitionend', function () {
            detailsDropdown.classList.remove('open');
          }, {
            once: true
          });
          
        }

      }
    }
  });

  // Product zoom on click image
  var productSlideshow = document.querySelector('.Product__Slideshow');
  var productZoom = document.querySelector('.RoundButton--zoom');
  if (productSlideshow && productZoom){
    productSlideshow.onclick = function(event){
      productZoom.click();
    }
  }
  
});
